import axios from 'axios';

import history from '../history';
import JWTHelperService from '../jwtHelper';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'content-type': 'application/json; charset=utf-8',
  },
});

axiosInstance.interceptors.request.use((config) => {
  requestTokenHandler(config);
  requestAuthorizationHandler(config);
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    // successHandler(response)
    responseStatusHandler(response);

    return response;
  },
  (error) => errorHandler(error),
);

const requestTokenHandler = (config) => {
  const token = JWTHelperService.getToken();
  if (token && JWTHelperService.isTokenExpired()) {
    JWTHelperService.logout();
    history.push('/session/signin');
    return;
  }
  return config;
};

const requestAuthorizationHandler = (config) => {
  const token = JWTHelperService.getToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};

const responseStatusHandler = (response) => {
  if ([401, 403].includes(response.status)) {
    JWTHelperService.clearToken();
    history.push('/');
  }
};

const errorHandler = (error) => {
  return Promise.reject(error);
};

export default axiosInstance;
